// This fixed reserve covers network fees, for when users click "max" to
// sell all their SOL in the trade module. In the future we can create
// further UX informing the user the requirement of this reserve.
// https://help.phantom.com/hc/en-us/articles/36320390739731-Unable-to-Swap-Tokens-on-the-Solana-Network#h_01JEV9CRW7S7SS4AHZKQVV4PD5
export const RESERVE_LAMPORTS_FOR_MAX_SOL_SELL = 10000000n; // 0.01 SOL
